import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Telegram, Youtube, Whatsapp } from "react-bootstrap-icons";


function Footer() {
  return (
    <footer
      className="text-dark pt-4 pb-2 mb-0"
      style={{ backgroundColor: "#f2f2f2" }}
    >
      <div className="container">
        <div className="row text-center text-md-start">
          {/* Column 1: About Us */}
            <div className="col-md-3 mb-3">
              <h6 className="text-capitalize fw-bold mt-3">About Us</h6>
              <ul className="list-unstyled small">
                <li>
                  <Link to="/about-us" className="text-dark aboutUs">
                    EthiocarHub.com
                  </Link>
                </li>
              </ul>
            </div>
            
            {/* Column 2: Quick Links */}
            <div className="col-md-3 mb-3">
              <h6 className="text-capitalize fw-bold mt-3">Quick Links</h6>
              <ul className="list-unstyled small quick-links">
                <li className="mb-2">
                  <Link to="/cars?condition=brand-new" className="text-dark">
                    New Cars
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/cars?condition=used" className="text-dark">
                    Used Cars
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/cars?type=electric" className="text-dark">
                    Electric Cars
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/cars?purpose=rent" className="text-dark">
                    Cars for Rent
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/login" className="text-dark">
                    Post Your Car
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Contact */}
            <div className="col-md-3 mb-3">
              <h6 className="text-capitalize fw-bold mt-3">Contact</h6>
              <p className="small mb-2">
                Email: <a href="mailto:support@ethiocarhub.com">support@ethiocarhub.com</a>
              </p>
              {/* <p className="small mb-0">Phone: +251-98-081-4848</p> */}
              <p className="small mb-0 d-flex align-items-center gap-2">
                Phone: +251-98-081-4848
                <a
                  href="https://wa.me/251980814848"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-success"
                >
                  <Whatsapp size={18} />
                </a>
              </p>
            </div>

            {/* Column 4: Follow Us */}
            <div className="col-12 col-md-3 mb-3">
              <h6 className="text-capitalize fw-bold mt-3">Follow Us:</h6>
              <div className="d-flex justify-content-center justify-content-md-start gap-4 mt-3 flex-wrap">
                <a
                  href="https://www.facebook.com/ethiocarhub"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark small"
                >
                  <Facebook size={16}  className="icon-facebook" />
                </a>
                {/* <a
                //   href="https://www.instagram.com/ethiocarhub"
                //   target="_blank"
                //   rel="noopener noreferrer"
                //   className="text-dark small"
                // >
                //   <Instagram size={16} className="icon-instagram"/>
                // </a> */}
                <a
                  href="https://www.twitter.com/ethiocarhub"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark small"
                >
                  <Twitter size={16} className="icon-twitter" />
                </a>
                <a
                  href="https://www.linkedin.com/ethiocarhub"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark small"
                >
                  <Linkedin size={16} className="icon-linkedin" />
                </a>
                <a
                  href="https://t.me/ethiocarhub"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark small"
                >
                  <Telegram size={16} className="icon-telegram"/> {/* Telegram Icon */}
                </a>
                <a
                  href="https://www.youtube.com/@ethiocarhub"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark small"
                >
                  <Youtube size={18} className="icon-youtube"/>
                </a>
              </div>
            </div>
      </div>
    </div>

      {/* Bottom border and copyright */}
      <div className="container-fluid px-0">
        <div className="text-center mt-3 small border-top pt-2">
          &copy; {new Date().getFullYear()} EthiocarHub.com. All rights reserved.
          &nbsp;|&nbsp;
          <Link
            to="/privacy-policy"
            className="text-dark text-decoration-none"
          >
            Privacy Policy
          </Link>
          &nbsp;|&nbsp;
          <Link
            to="/terms-and-conditions"
            className="text-dark text-decoration-none"
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
